import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { setLoadingSpinner } from '../actions/shared.action';
import { filter, map, mergeMap, of } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromSchoolActions from '../actions/school.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { AccountService } from 'src/app/services/account.service';
import { AppState } from '../app.state';
import { SchoolService } from 'src/app/services/school.service';

@Injectable()
export class SchoolEffects {

  getSchoolYear$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r: RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/school-year')
          || r.payload.routerState.url.startsWith('/home/applications')
          || r.payload.routerState.url.startsWith('/home/pre-enlistment')
          || r.payload.routerState.url.startsWith('/home/administration/setup/schedule-list')
          || r.payload.routerState.url.startsWith('/home/registrar/assign-schedule/view-schedules')
          || r.payload.routerState.url.startsWith('/home/registrar/assign-schedule/student-list')
          || r.payload.routerState.url.startsWith('/home/registrar/assessment/student-list')
          || r.payload.routerState.url.startsWith('/home/administration/setup/registrar-schedule-parameters')
          || r.payload.routerState.url.startsWith('/student/application-form-college')
          || r.payload.routerState.url.startsWith('/student/application-form-senior-high');
      }),
      mergeMap(() => {
        return this.schoolService.getSchoolYears().pipe(
          map((response: APIResponse) => {
            return fromSchoolActions.getSchoolYearSuccess({ data: response?.details});
          })
        );
      })
    );
  });

  getSchoolYearTerms$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r: RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/terms')
          || r.payload.routerState.url.startsWith('/home/applications')
          || r.payload.routerState.url.startsWith('/home/pre-enlistment')
          || r.payload.routerState.url.startsWith('/home/administration/setup/schedule-list')
          || r.payload.routerState.url.startsWith('/home/registrar/assign-schedule/view-schedules')
          || r.payload.routerState.url.startsWith('/home/registrar/assign-schedule/student-list')
          || r.payload.routerState.url.startsWith('/home/registrar/assessment/student-list')
          || r.payload.routerState.url.startsWith('/home/administration/setup/registrar-schedule-parameters')
          || r.payload.routerState.url.startsWith('/student/application-form-college')
          || r.payload.routerState.url.startsWith('/student/application-form-senior-high');
      }),
      mergeMap(() => {
        return this.schoolService.getSchoolYearTerms().pipe(
          map((response: APIResponse) => {
            return fromSchoolActions.getSchoolYearTermsSuccess({ data: response?.details});
          })
        );
      })
    );
  });

  getSchoolYearPeriods$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r: RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/periods');
      }),
      mergeMap(() => {
        return this.schoolService.getSchoolYearPeriods().pipe(
          map((response: APIResponse) => {
            return fromSchoolActions.getSchoolYearPeriodSuccess({ data: response});
          })
        );
      })
    );
  });

  getSchoolYearEvents$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r: RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/events');
      }),
      mergeMap(() => {
        return this.schoolService.getSchoolYearEvents().pipe(
          map((response: APIResponse) => {
            return fromSchoolActions.getSchoolYearEventsSuccess({ data: response});
          })
        );
      })
    );
  });

  getFormPrograms$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r: RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/student/application-form-senior-high')
          || r.payload.routerState.url.startsWith('/student/application-form-college');
      }),
      mergeMap(() => {
        return this.schoolService.getFormPrograms().pipe(
          map((response: APIResponse) => {
            return fromSchoolActions.getFormProgramsSuccess({ data: response?.details});
          })
        );
      })
    );
  });

  getProfessorList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r: RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/registrar/update-schedule-details')
          || r.payload.routerState.url.startsWith('/home/registrar/create-schedule-details')
      }),
      mergeMap(() => {
        return this.schoolService.getProfessorList().pipe(
          map((response: APIResponse) => {
            return fromSchoolActions.getProfessorListSuccess({ data: response?.details});
          })
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private schoolService: SchoolService,
    private store: Store<AppState>,
  ) { }

}
